import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { SidebarPortal } from '@plone/volto/components';
import Schema from './schema';
import GlossarioView from './View';
import { lerListaColada } from './glossario';

/** Edit do Glossário: o desenho do View, o painel de colar a lista e os campos
 *  na barra lateral. */
const GlossarioEdit = ({ data, onChangeBlock, block, selected }) => {
  const schema = Schema();
  const [colado, setColado] = useState('');
  const [resultado, setResultado] = useState(null);

  const ler = () => {
    const r = lerListaColada(colado);
    setResultado({ n: r.itens.length, ignoradas: r.ignoradas });
    if (r.itens.length) {
      onChangeBlock(block, { ...data, itens: r.itens });
      setColado('');
    }
  };
  // Enter e Esc no painel não sobem ao formulário da página.
  const naoSubir = (e) => e.stopPropagation();

  return (
    <>
      <GlossarioView
        data={data}
        id={block}
        vazio={
          <p className="ag-glossario__vazio">
            Glossário de siglas: cole a lista abaixo ou inclua as siglas na
            barra lateral.
          </p>
        }
      />
      {selected && (
        <div className="ag-glossario__colar" onKeyDown={naoSubir}>
          <label htmlFor={`colar-${block}`}>Colar a lista de siglas</label>
          <p>
            Uma sigla por linha, como &quot;UGP – Unidade de Gestão de
            Pessoas&quot; ou &quot;Unidade de Gestão de Pessoas (UGP)&quot;.
            Para dizer a que pertence, acrescente &quot;| Diretoria de
            Operações&quot; no fim. Colar de novo substitui a lista.
          </p>
          <textarea
            id={`colar-${block}`}
            rows={6}
            value={colado}
            onChange={(e) => setColado(e.target.value)}
          />
          <button type="button" onClick={ler} disabled={!colado.trim()}>
            Ler a lista
          </button>
          {resultado && (
            <p className="ag-glossario__colar-resultado" role="status">
              {resultado.n
                ? `${resultado.n} ${resultado.n === 1 ? 'sigla lida' : 'siglas lidas'}.`
                : 'Nenhuma sigla foi encontrada no texto colado.'}
              {resultado.ignoradas.length > 0 &&
                ` Ficou de fora: ${resultado.ignoradas.join(' / ')}`}
            </p>
          )}
        </div>
      )}
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

GlossarioEdit.propTypes = {
  data: PropTypes.object.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  block: PropTypes.string.isRequired,
  selected: PropTypes.bool,
};

export default GlossarioEdit;
